module.exports = __webpack_public_path__ + "img/network.c9211087.svg";